
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { Getter } from "vuex-class";
import { IPageResponse } from "@/services";
import {
  getLimitOrderTypeOptions,
  ICurrency,
  ILimit,
  ILimitType,
  Limit,
  SolCustomerOrderType,
} from "@/entities";

@Component({
  name: "add-edit-limit-modal",
  components: {
    Multiselect,
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AddEditLimitModal extends Vue {
  @Getter("getCurrenciesPage") currenciesPage?: IPageResponse<ICurrency>;
  @Prop({ required: true })
  limitList!: ILimit[];
  @Prop({ required: false })
  limit?: ILimit;

  private currency?: ICurrency;
  private amount?: number = 0;
  private type?: ILimitType;
  private limitValidationErrorKey = "validation.messages.limitAlreadyExists";

  get typeServiceOptions(): ILimitType[] {
    return getLimitOrderTypeOptions({
      [SolCustomerOrderType.DELIVERY]: "label.delivery.type",
    }).map(({ type, labelKey }) => ({
      code: type,
      description: this.$t(labelKey) as string,
    }));
  }

  constructor() {
    super();
  }
  async mounted(): Promise<void> {
    extend("currency_unique", {
      validate: async () => {
        if (this.currency) {
          return !this.limitList?.find(
            (l) =>
              this.limit !== l && l.currency?.id === this.currency?.id && l.type === this.type?.code
          );
        }
        return true;
      },
      message: () => this.$t("validation.messages.limitAlreadyExists") as string,
    });

    extend("order_type_unique", {
      validate: async () => {
        if (this.type) {
          return !this.limitList?.find(
            (l) =>
              this.limit !== l && l.type === this.type?.code && l.currency?.id === this.currency?.id
          );
        }
        return true;
      },
      message: () => this.$t("validation.messages.limitAlreadyExists.orderType") as string,
    });
  }

  initData(): void {
    this.currency = this.currenciesPage?.content.find((c) => c.id === this.limit?.currency?.id);
    this.amount = this.limit?.amount;
    this.type = this.typeServiceOptions.find((t) => t.code === this.limit?.type);
  }

  async onSubmit(): Promise<void> {
    if (this.limit) {
      this.limit.currency = this.currency;
      this.limit.amount = this.amount;
      this.limit.type = this.type?.code;
    } else {
      const newLimit = new Limit({
        amount: this.amount,
        currency: this.currency,
        type: this.type?.code,
      });

      this.limitList.push(newLimit);
    }
    this.$bvModal.hide("addEditLimitModal");
  }
}
